





















import { defineComponent, PropType } from "@nuxtjs/composition-api";
import type { RemovableFilterInterface } from "~/modules/catalog/category/components/filters/useFilters";

export default defineComponent({
  name: "FilterNavBar",
  props: {
    removableFilters: {
      type: Array as PropType<RemovableFilterInterface[]>,
      default: () => []
    }
  },
  setup(_, { emit }) {
    const doRemoveFilter = (filter: RemovableFilterInterface) => {
      emit("removeFilter", { id: filter.id, value: filter.value });
    };

    const clearAllFilters = () => {
      emit("clearAllFilters");
    };

    return { doRemoveFilter, clearAllFilters };
  },
});
